module.exports = __webpack_public_path__ + "img/frame1.ff041741.png";